import { useSelector } from "react-redux";
import { formatAmount } from "utils/helper";
import React, { useState, useEffect } from "react";
import { Typography, Select, Loader } from "components";
import transactionVolumeImg from "assets/images/volume-chart-img.svg";
import { getRegionStats } from "redux/actions/dashboard/terminalDashboardActions";
import {
  XAxis,
  YAxis,
  ResponsiveContainer,
  BarChart,
  Bar,
  Cell,
  Tooltip,
} from "recharts";

const TransactionVolumeAnalytics = () => {
  const [dataToDisplay, setDataToDisplay] = useState("1");

  useEffect(() => {
    getRegionStats();
  }, []);

  const { loading, data } = useSelector(
    (state) => state.terminalDashboardReducer.regionStats
  );

  const newData = data.details?.map(({ volume, value, region }) => ({
    region: region,
    value: dataToDisplay === "1" ? volume : value,
  }));

  const colorCodes = [
    "#2544A0",
    "#0C1575",
    "#7B61FF",
    "#3784FB",
    "#79D7F5",
    "#19D3FC",
    "#C9D6FF",
    "#1966FC",
    "#9791CC",
    "#778CA2",
  ];

  return (
    <div className="dashboard-card terminal-value-chart-container">
      <div className="terminal-value-chart chart pb-0">
        <div className="d-flex justify-content-between align-items-center  pt-2 pb-3">
          <div>
            <Select
              required={false}
              placeholder="Select reason"
              className={"data-type-select"}
              name="dataType"
              onChange={(e) => setDataToDisplay(e.target.value)}
              value={dataToDisplay}
              options={[
                { label: "Transaction Volume", value: "1" },
                { label: "Transaction Value", value: "2" },
              ]}
            />
            <div className="d-flex align-items-center">
              <Typography state="primary" variant="body2" className={"mt-2"}>
                {dataToDisplay === "1"
                  ? formatAmount(data.totalTransVolume)
                  : formatAmount(data.totalTransValue)}{" "}
              </Typography>{" "}
              &nbsp;
              <img
                src={transactionVolumeImg}
                height="13px"
                alt=""
                className="mt-2"
              />{" "}
            </div>
          </div>
        </div>
        {loading ? (
          <div
            className={"text-center"}
            style={{ marginTop: "6rem", height: "13rem" }}
          >
            <Loader />
            <Typography state="grey" variant="body2">
              Loading data...
            </Typography>
          </div>
        ) : newData?.length ? (
          <div style={{ height: "100%" }} className="region-analytics-chart">
            <ResponsiveContainer width="100%" height="67%">
              <BarChart
                width={730}
                height={250}
                data={newData}
                margin={{ left: 14, bottom: 40 }}
                barCategoryGap={0}
                barGap={0}
              >
                <XAxis
                  dataKey="region"
                  dy={30}
                  angle={-90}
                  // axisLine={false}
                  tickSize={6}
                  minTickGap={-20}
                  style={{
                    fontSize: "9px",
                    fontWeight: 500,
                    fontFamily: "Work Sans",
                    color: "#9A9A9A",
                  }}
                />
                <YAxis
                  style={{
                    fontSize: "10px",
                    fontFamily: "Work Sans",
                    color: "#9A9A9A",
                  }}
                  tickSize={0}
                  tickFormatter={(val) => formatAmount(val)}
                  dx={-10}
                />
                <Tooltip />
                <Bar dataKey="value" barSize={18} strokeWidth={0}>
                  {newData?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colorCodes[index]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <Typography
            state="grey"
            variant="body2"
            className={" text-center mtop-4 mbottom-4"}
          >
            No information within the selected dates
          </Typography>
        )}
      </div>
    </div>
  );
};

export default TransactionVolumeAnalytics;
